import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.9752 6.65388L15.7727 11.4514C16.0758 11.7544 16.0758 12.2457 15.7727 12.5487L10.9752 17.3462C10.4864 17.835 9.6506 17.4888 9.6506 16.7975V7.20256C9.6506 6.51126 10.4864 6.16505 10.9752 6.65388Z",
		fill: "currentColor"
	})
});
export default SvgCaretRight;
